import { useRequiredParams } from '@pba/react-router';
import { LandingLayout } from 'layouts';
import { PublicGiving } from 'features/givings';
import { Footer, Header, type HeaderItem } from 'features/onboarding';
import type { OnboardingLocationState } from 'pages/types';
import { useGivingNavigation, useOnboardingNavigation } from '../../hooks';
import { useGiveTransactionParams } from '../hooks';

const PagePublicGiving = () => {
  const { givingId } = useRequiredParams<{ givingId: string }>();
  const { paymentRedirectUrl } = useGivingNavigation();
  const giveTransaction = useGiveTransactionParams();
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onNavigateToPrimaryLogin } = useOnboardingNavigation<OnboardingLocationState>();

  const headerButtons: HeaderItem[] = [
    {
      label: 'Log in',
      async onClick() {
        await onNavigateToPrimaryLogin({ referrer: window.location.pathname });
      },
      type: 'primary',
    },
  ];

  return (
    <LandingLayout
      contentRight={
        <PublicGiving giveTransaction={giveTransaction} givingId={givingId} paymentRedirectUrl={paymentRedirectUrl} />
      }
      footer={<Footer />}
      header={<Header items={headerButtons} />}
      type="public-detail"
    />
  );
};

export default PagePublicGiving;
